import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import RoleSelector from './RoleSelector';
import { LogOutIcon, UserIcon } from 'lucide-react';
interface HeaderProps {
  currentRole: 'user' | 'manager';
  onRoleChange: (role: 'user' | 'manager') => void;
}
const Header: React.FC<HeaderProps> = ({
  currentRole,
  onRoleChange
}) => {
  const {
    isAuthenticated,
    userEmail,
    logout
  } = useAuth();
  return <div className="bg-white w-full p-4 shadow-md flex justify-between items-center" data-id="element-63">
      <div className="font-bold text-xl text-blue-600" data-id="element-64">Route Optimizer</div>
      <div className="flex items-center space-x-4" data-id="element-65">
        <RoleSelector currentRole={currentRole} onRoleChange={onRoleChange} data-id="element-66" />
        {isAuthenticated && <div className="flex items-center ml-4" data-id="element-67">
            <div className="flex items-center mr-4 text-sm text-gray-700" data-id="element-68">
              <UserIcon className="w-4 h-4 mr-1" data-id="element-69" />
              <span className="hidden md:inline" data-id="element-70">{userEmail}</span>
            </div>
            <button onClick={logout} className="inline-flex items-center px-3 py-1.5 border border-gray-300 shadow-sm text-sm font-medium rounded text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500" data-id="element-71">
              <LogOutIcon className="w-4 h-4 mr-1" data-id="element-72" />
              <span className="hidden sm:inline" data-id="element-73">Logout</span>
            </button>
          </div>}
      </div>
    </div>;
};
export default Header;